import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p>
      Made with
      <span role="img" aria-label="Heart"> 💙 </span>
      by
      <a href="https://www.twitter.com/amincharoliya" alt="Amin Charoliya">@amincharoliya</a>
    </p>
  </footer>
);

export default Footer;
